import { render, staticRenderFns } from "./productById.vue?vue&type=template&id=0406c95a&scoped=true&"
import script from "./productById.vue?vue&type=script&lang=js&"
export * from "./productById.vue?vue&type=script&lang=js&"
import style0 from "./productById.vue?vue&type=style&index=0&id=0406c95a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0406c95a",
  null
  
)

export default component.exports